/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class HistoryMenuModel {
  url: string | undefined = undefined;
  label: string | undefined = undefined;
  type: string | undefined = undefined;
  key: string | undefined = undefined;
  timestamp: Date | undefined = undefined;

  constructor(url: string, label: string, type: string, key: string) {
    this.url = url;
    this.label = label;
    this.type = type;
    this.key = key;
  }
}
